<template>
  <div>
    <ProjectItem v-for="(item, index) in list" :key="index">
      <ProjectTitle v-if="index == 0" :title="title"></ProjectTitle>
      <IconTitle
        :label="item.classifyLabel"
        :result="item.result"
        :type="getType(item)"
        :describe="describe(item)"
        :remark="remark(item)"
      ></IconTitle>
      <div class="item-content">
        <div class="title">状态分析</div>
        <ColorBar
          :type="getType(item)"
          :legend="getLegend(item)"
          :percent="getPercent(item)"
        ></ColorBar>
        <div class="detail">
          <div class="title">建议:</div>
          <div v-html="item.appraise"></div>
        </div>
      </div>
    </ProjectItem>
  </div>
</template>

<script>
import ProjectItem from "../item.vue";
import ProjectTitle from "../title.vue";
export default {
  props: ["title", "report"],
  components: {
    ProjectItem,
    ProjectTitle,
  },
  computed: {
    ReportData() {
      return this.$store.state.ReportData || {};
    },
    list() {
      return this.ReportData[this.report] || [];
    },
  },
  methods: {
    getType(item) {
      let n = Number(item.gradeValue);
      if (n > 5) {
        return "xiao";
      } else {
        return "ku";
      }
    },
    getLegend(item) {
      return this.getArray(item).map((m) => m.dictLabel);
    },
    getPercent(item) {
      let array = this.getArray(item);
      let index = array.findIndex((e) => e.dictValue == item.gradeValue);
      return index * 20 + 10;
    },
    getArray(item) {
      let type = this.getType(item);
      if (type == "xiao") {
        return item.gradeList.slice(-5);
      } else {
        return item.gradeList.slice(0, 5).reverse();
      }
    },
    describe(item) {
      return item.describe;
    },
    remark(item) {
      let row = item.gradeList.find((f) => f.dictValue == item.gradeValue);
      if (row) {
        return row.remark;
      } else {
        return "";
      }
    },
  },
};
</script>

<style scoped lang="scss">
.item-content {
  padding: 10px 0 10px 10px;
  .title {
    color: #333;
  }
  .detail {
    margin-top: 10px;
    font-size: 14px;
    .title {
      color: red;
      font-weight: 600;
      margin-bottom: 5px;
    }
  }
}
</style>